@if (value?.length) {
  <div [nbSpinner]="!!(loading$|async)"
       class="building-equipments"
       [sortableArray]="value"
       [sortableOptions]="sortableOptions">
    @for (item of value; track item.id) {
      <div class="building-equipment">
        <div class="name-and-description">
          <div class="name">
            <nb-icon pack="fas" icon="cube"></nb-icon>
            <span>{{item.equipment.name}}</span>
          </div>
          <div class="description">
            <div>
              <b>Anzahl:</b>
              <span>{{item.quantity}}</span>
            </div>
            <div>
              <b>Firma:</b>
              <span>{{item.creatorTenant.name}}</span>
            </div>
            <div>
              <b>Gebäudeteil:</b>
              <span>{{item.sectionText}}</span>
              @if (isBuildingSectionMismatch(item)) {
                <nb-icon class="mismatch"
                         icon="alert-triangle-outline"
                         pack="eva"
                         status="warning"
                         nbTooltip="TGA ist nicht im selben Gebäudeteil wie die Prüfpunktzeile"
                         nbTooltipStatus="warning"></nb-icon>
              }
            </div>
          </div>
        </div>
        <div class="flex-grow"></div>
        <button nbButton
                (click)="showDetailWindow(item)"
                nbTooltip="TGA bearbeiten"
                nbTooltipStatus="info">
          <nb-icon pack="eva" icon="external-link-outline"></nb-icon>
        </button>
        @if (!isDisabled) {
          <button nbButton
                  nbTooltip="TGA entfernen"
                  nbTooltipStatus="warning"
                  ghost
                  (click)="removeBuildingEquipment(item)">
            <nb-icon pack="eva" icon="close"></nb-icon>
          </button>
        }
      </div>
    }
  </div>
} @else {
  <div class="text-hint">Keine TGAs ausgewählt</div>
}

<div class="center-button">
  @if (!isDisabled) {
    <button nbButton
            type="button"
            size="large"
            [nbPopover]="popoverMenu"
            [nbPopoverPlacement]="NbPosition.TOP">
      <nb-icon icon="plus-outline" pack="eva"></nb-icon>
    </button>
  }
</div>

<ng-template #popoverMenu>
  <div class="building-equipment-add">
    <wr-list-view [items]="notSelectedBuildingEquipments$|async"
                  [searchText]="text$.value"
                  (searchTextChange)="text$.next($event)"
                  (selectedChange)="addBuildingEquipment($event)"
                  (addItemClicked)="createNewBuildingEquipment()">
      <ng-template wrListItem let-item>
        <div class="building-equipment-add-item">
          <nb-icon pack="fas" icon="cube"></nb-icon>
          <div class="building-equipment-list-item-name">
            <span>{{item.equipment.name}} x {{item.quantity}}</span>
            <span class="address">{{item.sectionText}}</span>
            <span class="address">{{item.creatorTenant.name}}</span>
          </div>
        </div>
      </ng-template>
    </wr-list-view>
  </div>
</ng-template>
